
import "@/styles/pages/recordAllScreen/index.css";
import registerViewer from "@/components/viewer";
import registerVideoViewer from "@/components/videoViewer";
import registerOpenVideo from "@/components/openVideo";
import registerSlider from "/framework/components/slider";
import registerFit from "@/components/fit";
import registerTab from "@/components/tab";
import registerCountedShare from "@/components/countedShare";
import registerOurDomain from "@/components/ourDomain";
import registerStartRecord from "@/components/startRecord";
import registerMouseScrollDownDiv from "@/components/mouseSCrollDownDiv";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // online-video-downloader
// /free-online-video-downloader.php
new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    $.register = $.registerComponent;
    window.apowerTrans = window.$apTranslations;
    window.apower = apower;
    apower.agents = {};
    $(".start-video-downloader").on("click", function (event) {
      $(".desktop-win").com().show();
      event.stopPropagation();
      return false;
    });
    $(".desktop-win .ok").click(function () {
      $(".desktop-win").stop().fadeOut(200);
      $(".win-mask").stop().fadeOut(200);
    });
    $(".desktop-win .cancel").click(function () {
      $(".desktop-win").hide();
      $(".win-mask").hide();
    });
    registerViewer($, apower);
    registerVideoViewer($, apower);
    registerOpenVideo($, apower);
    registerSlider($, apower);
    registerFit($, apower);
    registerCountedShare($, apower);
    registerTab($, apower);
    registerStartRecord($, apower);
    registerMouseScrollDownDiv($, apower);
    // $.registerOnce(".mouse-scroll-down", function () {
    //   this.el.$on("click", function () {
    //     stages.scrollScreen(1);
    //   });
    // });
    // //for toggle screens
    // var stages = $.registerOnce({
    //   ref: {
    //     screens: ".screen",
    //     header: ".header",
    //     subheader: ".subheader",
    //     shareEl: ".global-bottom-share",
    //   },

    //   screenIndex: 0,

    //   init: function () {
    //     var isMac = /mac/i.test(navigator.userAgent);

    //     if ($(window).width() > 768) {
    //       $(document).$on(
    //         "wheel",
    //         $.throttle(this.onWhell, isMac ? 2500 : 500),
    //         this
    //       );

    //       if ($.env.isTouch) {
    //         this.screens.onPan(this.onPanforPad, this);
    //       }
    //     } else {
    //       this.onMobile();
    //       $(document).$on(
    //         "scroll",
    //         $.blockFn(this.checkIfAnimationActive, 100),
    //         this
    //       );
    //     }
    //   },

    //   scrollScreen: function (newIndex, isRelative) {
    //     var direction = newIndex;
    //     var oldIndex = this.screenIndex;

    //     if (isRelative) {
    //       newIndex = this.screenIndex + newIndex;

    //       if (newIndex >= this.screens.length) {
    //         newIndex = 0;
    //       } else if (newIndex < 0) {
    //         newIndex = this.screens.length - 1;
    //       }
    //     }

    //     this.screenIndex = newIndex;
    //     var oldScreen = this.screens.eq(oldIndex);
    //     var newScreen = this.screens.eq(newIndex);

    //     if (direction === -1 || direction === 1) {
    //       this.screens.removeClass("last-active").removeClass("active");
    //       oldScreen.removeClass("active").addClass("last-active");

    //       if (oldScreen.is(".step-screen")) {
    //         operationstep.stopFunAnim();
    //       }
    //     }

    //     $(".video-wrap video").trigger("pause");
    //     $("[data-video-viewer]").find(".viewer-close").click();

    //     if (newScreen.is(".download-video") && $(window).width() > 768) {
    //       newScreen.find(".video-wrap video").trigger("play");
    //     }

    //     newScreen.addClass("active");

    //     if (newScreen.is(".step-screen")) {
    //       // operationstep.anim[operationstep.lastFunName].el.com().play()
    //     }

    //     if (
    //       direction == 1 ||
    //       this.screenIndex === 0 ||
    //       this.screenIndex === this.screens.length - 1
    //     ) {
    //       this.shareEl.fadeOut(200);
    //     } else if (direction == -1) {
    //       this.shareEl.fadeIn(200);
    //     }

    //     if (this.screenIndex === 0) {
    //       this.header.fadeIn(200);
    //       this.subheader.fadeOut(200);
    //     } else {
    //       this.header.fadeIn(200);
    //       this.subheader.fadeIn(200);

    //       var logo = this.subheader.find(".logo");

    //       logo.$on("click", this.onSubheaderLogo, this);
    //     }
    //   },

    //   onSubheaderLogo: function () {
    //     this.screens.removeClass("last-active");
    //     this.screens
    //       .eq(this.screenIndex)
    //       .removeClass("active")
    //       .addClass("last-active");
    //     this.screens.eq(0).addClass("active");

    //     this.subheader.fadeOut(200);
    //   },

    //   onWhell: function (e) {
    //     var screen = this.screens.eq(this.screenIndex);
    //     var direction = e.deltaY > 0 ? 1 : -1;

    //     if (screen.is(".faq-screen")) {
    //       var scrollTop = screen.scrollTop();
    //       if (direction === 1) {
    //         if (scrollTop + screen[0].clientHeight < screen[0].scrollHeight) {
    //           return;
    //         }
    //       } else {
    //         if (scrollTop > 0) {
    //           return;
    //         }
    //       }
    //     }

    //     this.scrollScreen(direction, true);
    //   },

    //   onPanforPad: function (tempDirection) {
    //     if (tempDirection === "t" || tempDirection === "b") {
    //       var direction = tempDirection === "t" ? 1 : -1;

    //       this.scrollScreen(direction, true);
    //       var screen = this.screens.eq(this.screenIndex);

    //       if (direction === 1) {
    //         this.header.fadeOut(200);
    //       } else if (direction === -1) {
    //         this.header.fadeIn(200);
    //       }

    //       if (screen.is(".step-screen")) {
    //         this.header.fadeOut(200);
    //       }

    //       if (this.screenIndex == 0) {
    //         this.header.fadeIn(200);
    //       }
    //     }
    //   },

    //   onMobile: function () {
    //     var moreHTML = apower.trans(
    //       '<div class="learn-more">' +
    //         "<div>{@learn_more}</div>" +
    //         "</div>" +
    //         '<div class="pack-up">' +
    //         "<div>{@pack_up}</div>" +
    //         "</div>"
    //     );

    //     $(".function .writing p").after(moreHTML);
    //     $.applyCom(".function .writing");
    //   },

    //   checkIfAnimationActive: function () {
    //     var scrollTop = $("html").scrollTop() || $("body").scrollTop(),
    //       windowHeight = $(window).height(),
    //       stepScreen = $(".step-screen"),
    //       top = stepScreen.offset().top,
    //       bot = top + stepScreen[0].offsetHeight;

    //     var index = stepScreen.children(".active").index(),
    //       funname = operationstep.funNames[index];

    //     if (bot <= scrollTop || top >= scrollTop + windowHeight) {
    //       operationstep.stopFunAnim();
    //       stepScreen.removeClass("active");
    //     } else {
    //       if (!stepScreen.hasClass("active")) {
    //         // operationstep.anim[funname].el.com().play()
    //       }
    //       stepScreen.addClass("active");
    //     }
    //   },
    // });

    if ($.env.isSafari && $(window).width() < 768) {
      var videobtn = $("[data-video-show]").find(".video-button");
      videobtn.remove();
    }

    //function share
    $.registerOnce(".function.share", {
      ref: {
        iconEl: ".obj-wrap .icon",
        objWrap: ".obj-wrap",
      },

      init: function () {
        this.objWrap.$on("inview", this.onInview, this);
        this.objWrap.$on("outview", this.onOutview, this);

        this.objWrap.$on("mouseenter", this.onMouseEnter, this);
        this.objWrap.$on("mouseleave", this.onMouseLeave, this);
        this.iconEl.$on("mouseenter", this.onMouseEnterIcon, this);
      },

      onMouseEnter: function () {
        this.onOutview();
      },

      onMouseLeave: function () {
        this.onInview();
      },

      onMouseEnterIcon: function (e) {
        var el = $(e.currentTarget);

        this.iconEl.removeClass("active");
        el.addClass("active");
      },

      onInview: function () {
        if (this.timer) {
          return;
        }

        var index = Math.ceil(Math.random() * 4 + 0.1) - 1;
        this.iconEl.removeClass("active");
        this.iconEl.eq(index).addClass("active");

        var lastIndex;

        this.timer = setInterval(
          function () {
            var index = Math.ceil(Math.random() * 4 + 0.1) - 1;

            if (lastIndex == index && index < this.iconEl.length - 1) {
              index = index + 1;
            } else if (lastIndex == index && index == this.iconEl.length - 1) {
              index = index - 1;
            }

            this.iconEl.removeClass("active");
            this.iconEl.eq(index).addClass("active");

            lastIndex = index;
          }.bind(this),
          5000
        );
      },

      onOutview: function () {
        clearInterval(this.timer);
        this.timer = 0;
        this.iconEl.removeClass("active");
      },
    });

    //for trigger main video play  and change color
    $.registerOnce(".main", {
      init: function () {
        this.el.$on("inview", this.onInview, this);
        this.el.$on("outview", this.onOutview, this);

        this.video = this.el.find("video");
        this.bgColorEl = this.el.find(".bg-color");
      },

      onInview: function () {
        this.video.trigger("play");
      },

      onOutview: function () {
        this.video.trigger("pause");
      },
    });

    //give ul-content p min-height
    $.registerOnce(".here", {
      ref: {
        wrapEl: ".functions >a",
      },

      init: function () {
        if (window.innerWidth > 768) {
          this.setMinHeight();

          $(window).$on("resize", this.setMinHeight.bind(this));
        }
      },

      setMinHeight: function () {
        var arrP = [];
        var arrH = [];

        var p = this.wrapEl.find("p");
        var title = this.wrapEl.find("h3");

        p.css("min-height", "");
        title.css("min-height", "");
        var i;
        for (i = 0; i < this.wrapEl.length; i++) {
          arrP.push(p[i].offsetHeight);
          arrH.push(title[i].offsetHeight);
        }

        for (i = 0; i < this.wrapEl.length; i++) {
          if (i % 3 == 0) {
            var maxP = Math.max.apply(null, arrP.slice(i, i + 3));
            var maxTitle = Math.max.apply(null, arrH.slice(i, i + 3));

            p.slice(i, i + 3).css("min-height", maxP);
            title.slice(i, i + 3).css("min-height", maxTitle);
          }
        }
      },
    });

    //record
    $.registerOnce(".record", {
      ref: {
        objWrap: ".obj-wrap",
        shadowEl: ".shadow",
        play: ".shadow .play",
        frameEl: ".frame",
        audioLine: ".audio-line",
        audioBtn: ".audio-btn",
        cameraBtn: ".camera-btn",
        select: ".select",
        selectMouse: ".select-mouse",
        cursor: ".cursor",
        hideEl: ".hide",
        recBtn: ".rec-btn",
        screen: ".screen",
        screenCamera: ".screen-camera",
        bottomEl: ".bottom",
        bottomBtn: ".bottom >div",
        recScreenBtn: ".rec-screen",
        audio: ".audio",
        windowsBtn: ".windows",
        mouseBtn: ".mouse",
        number: ".number",
        three: ".number .three",
        two: ".number .two",
        one: ".number .one",
        mouseSelect: ".mouse-select",
      },

      init: function () {
        this.hideEl.css("display", "none");

        this.objWrap.$on("inview", this.onInview, this);
        this.objWrap.$on("outview", this.onOutview, this);

        this.play.$on("click", this.onClickPlay, this);
        this.recScreenBtn.$on("click", this.recScreenPlay, this);
        this.audio.$on("click", this.audioPlay, this);
        this.windowsBtn.$on("click", this.windowsPlay, this);
        this.mouseBtn.$on("click", this.mousePlay, this);
      },

      stopPlay: function () {
        this.objWrap.find("*").stop(true);
      },

      onInview: function () {
        this.firstPlay();
      },

      onOutview: function () {
        this.stopPlay();
      },

      onClickPlay: function () {
        var el = this.bottomEl.find(".active");

        el.click();
      },

      recScreenPlay: function (e) {
        this.bottomBtn.removeClass("active");
        $(e.currentTarget).addClass("active");
        this.stopPlay();
        this.screen.fadeIn(200);
        this.audioLine.css({ height: 0 });
        this.hideEl.css("display", "none");
        this.cursor.css({ top: 74, left: 150 }).stopableDelay(500);
        this.cursor.animate({ top: 112, left: 175 }, 600);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.cameraBtn.stopableDelay(1500).fadeIn(400);
        this.cursor.stopableDelay(800).animate({ top: 110, left: 372 }, 500);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.recBtn
          .stopableDelay(2800)
          .animate({ opacity: 0.5 }, 400)
          .animate({ opacity: 1 }, 200);
        this.screenCamera.stopableDelay(3400).fadeIn(200);
        this.shadowEl.stopableDelay(3800).fadeIn(400);
      },

      audioPlay: function (e) {
        this.bottomBtn.removeClass("active");
        $(e.currentTarget).addClass("active");
        this.stopPlay();
        this.screen.fadeIn(200);
        this.audioLine.css({ height: 0 });
        this.hideEl.css("display", "none");
        this.audioLine.css({ height: 0 });
        this.cursor.css({ top: 74, left: 150 }).stopableDelay(500);
        this.cursor.animate({ top: 109, left: 112 }, 600);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.audioBtn.stopableDelay(1500).fadeIn(400);
        this.cursor.stopableDelay(800).animate({ top: 110, left: 372 }, 500);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.recBtn
          .stopableDelay(3200)
          .animate({ opacity: 0.5 }, 400)
          .animate({ opacity: 1 }, 200);
        this.audioLine
          .stopableDelay(3800)
          .animate({ height: 10 }, 300)
          .animate({ height: 20 }, 300)
          .animate({ height: 8 }, 300)
          .animate({ height: 30 }, 300)
          .animate({ height: 15 }, 300)
          .animate({ height: 24 }, 300)
          .animate({ height: 7 }, 300)
          .animate({ height: 17 }, 300);
        this.shadowEl.stopableDelay(6400).fadeIn(400);
      },

      windowsPlay: function (e) {
        this.bottomBtn.removeClass("active");
        $(e.currentTarget).addClass("active");

        this.stopPlay();
        this.firstPlay();
      },

      firstPlay: function () {
        this.screen.fadeIn(200);
        this.hideEl.css("display", "none");
        this.screen.fadeIn(200);
        this.audioLine.css({ height: 0 });
        this.cursor.css({ top: 74, left: 150 }).stopableDelay(500);
        this.cursor.animate({ top: 102, left: 256 }, 600);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.select.stopableDelay(1800).fadeIn(400);
        this.cursor.stopableDelay(300).animate({ top: 152, left: 256 }, 500);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.cursor.animate({ top: 110, left: 372 }, 500);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.recBtn
          .stopableDelay(3700)
          .animate({ opacity: 0.5 }, 400)
          .animate({ opacity: 1 }, 200);
        this.screen.stopableDelay(4300).fadeOut(400);
        this.number.stopableDelay(4700).fadeIn(400);
        this.three
          .stopableDelay(4700)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);
        this.two
          .stopableDelay(5800)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);
        this.one
          .stopableDelay(6900)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);

        this.shadowEl.stopableDelay(7500).fadeIn(400);
      },

      mousePlay: function (e) {
        this.bottomBtn.removeClass("active");
        $(e.currentTarget).addClass("active");
        this.stopPlay();
        this.hideEl.css("display", "none");
        this.audioLine.css({ height: 0 });
        this.screen.fadeIn(200);
        this.cursor.css({ top: 74, left: 150 }).stopableDelay(500);
        this.cursor.animate({ top: 102, left: 256 }, 600);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.selectMouse.stopableDelay(1800).fadeIn(400);
        this.cursor.stopableDelay(300).animate({ top: 202, left: 276 }, 500);
        this.cursor.animate({ opacity: 0.5 }, 200).animate({ opacity: 1 }, 200);
        this.cursor.animate({ top: 110, left: 372 }, 500);
        this.mouseSelect.stopableDelay(2500).fadeIn(400);
        this.cursor
          .stopableDelay(400)
          .animate({ opacity: 0.5 }, 200)
          .animate({ opacity: 1 }, 200);
        this.screen.stopableDelay(4200).fadeOut(400);
        this.number.stopableDelay(4500).fadeIn(400);
        this.three
          .stopableDelay(4500)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);
        this.two
          .stopableDelay(5300)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);
        this.one
          .stopableDelay(6600)
          .animate({ opacity: 1 }, 200)
          .animate({ opacity: 0 }, 400);
        this.shadowEl.stopableDelay(7000).fadeIn(400);
      },
    });

    //B页面record-screen-activity
    $.registerOnce(".record-screen-activity", {
      ref: {
        iconEl: "ul li",
        objWrap: ".obj-wrap>div",
      },

      init: function () {
        this.el.$on("inview", this.onInview, this);
        this.el.$on("outview", this.onOutview, this);
        // this.objWrap.$on('mouseleave', this.onMouseLeave, this)
        this.iconEl.$on("mousedown", this.onOutview, this);
        this.iconEl.$on("mouseup", this.onMouseUp, this);
      },

      onMouseUp: function () {
        setTimeout(this.onInview(), 10000);
      },

      onInview: function () {
        if (this.timer) {
          return;
        }

        var index = 0;
        this.iconEl.removeClass("active");
        this.iconEl.eq(index).addClass("active");
        this.objWrap.removeClass("active");
        this.objWrap.eq(index).addClass("active");

        this.timer = setInterval(
          function () {
            this.iconEl.removeClass("active");
            this.iconEl.eq(index).addClass("active");
            this.objWrap.removeClass("active");
            this.objWrap.eq(index).addClass("active");

            if (index < this.iconEl.length - 1) {
              index++;
            } else if (index == this.iconEl.length - 1) {
              index = 0;
            }
          }.bind(this),
          5000
        );
      },

      onOutview: function () {
        clearInterval(this.timer);
        this.timer = 0;
        this.iconEl.removeClass("active");
        this.objWrap.removeClass("active");
      },
    });

    function checkPromoteAds() {
      function _buildEl(url, bannerUrl) {
        if (url) {
          //活动弹窗
          let el = document.createElement("div");
          el.classList.add("rec-promotion-container");
          el.id = "rec-promotion-container-id";
          const img = document.createElement("img");
          img.classList.add("rec-promotion-img");
          img.src = url;
          const closeBtn = document.createElement("div");
          closeBtn.classList.add("close-it");

          img.onclick = function () {
            window.open("/store/order-apowerrec.html", "_self");
          };

          closeBtn.onclick = function () {
            el.remove();
          };

          el.appendChild(img);
          el.appendChild(closeBtn);

          document.body.appendChild(el);
        }

        if (bannerUrl) {
          //购买按钮小banner img
          const banner = document.createElement("img");
          banner.classList.add("promotion-ads-banner");
          banner.src = bannerUrl;
          const buyBtn = document.querySelector(".download-desktop .buy");
          buyBtn.appendChild(banner);
        }
      }

      function fetchData(lang) {
        const url = () => {
          const dev = "https://devgw.aoscdn.com/base/support";
          const prod = "https://gw.aoscdn.com/base/support";

          let url = window.apower.user.isDev() ? dev : prod;
          // url += `/v2/client/promote-ads/166?language=${apower.lang}`;
          url += `/v2/client/promote-ads/166?language=${lang}&type=1&platform=2`;
          return url;
        };

        return new Promise((resolve, reject) => {
          $.ajax({
            url: url(),
            type: "GET",
            dataType: "json",
            success: function (res) {
              resolve(res);
            },
            error: function (err) {
              reject(err);
            },
          });
        });
      }

      Promise.all([fetchData("en"), fetchData(apower.lang)]).then((res) => {
        const [en, zh] = res;
        const finalData = {
          ...en.data,
          ...zh.data,
        };

        const { start_time, end_time, image_url_default, image_url_back } =
          finalData;
        const now = Date.now() / 1000;
        if (now > start_time && now < end_time) {
          _buildEl(image_url_default, image_url_back);
        }
      });
    }
    const langs = ["zh", "en", "tw", "fr", "ja", "de", "pt", "es"];
    if (langs.includes(apower.lang)) {
      checkPromoteAds();
    }

    $.register("rec-promotion", "win", {
      template: `
      
      <div class="win rec-promotion">
      <div class="rec-promotion-header-bg"></div>
      <div class="win-body">
          <div class="promotion-pannel">
            <div class="promotion-pannel-header">
              <h2>{{titleStr}}</h2>
            </div>
            <div class="promotion-title-box">
              <div class="promotion-title-bg">
                <div class="promotion-title-star1"></div>
                <div class="promotion-title-star2"></div>
              </div>
              <p>{{desStr}}</p>
            </div>
            <div class="des-box">
              <div class="des-bg"></div>
              <div class="des-tip tip-up">
              {{buy1get2Str}}
              </div>
              <div class="des-tip">
              {{unlimitedPackStr}}
              </div>
            </div>
            <div class='discount'>
              <div class="inline-box">
                <span>{{offerEndStr}}</span>
                <div class="count-down-box">
                  <div class="count-down-item">
                    <p class="count-down-item-text js-hrs">1</p>
                    <span class="count-down-item-label">{{hourStr}}</span>
                  </div>
                  <div class="count-down-item">
                    <p class="count-down-item-text js-mins"></p>
                    <span class="count-down-item-label">{{minStr}}</span>
                  </div>
                  <div class="count-down-item">
                    <p class="count-down-item-text js-secs">22</p>
                    <span class="count-down-item-label">{{secStr}}</span>
                  </div>
                  <div class="count-down-item msecs">
                    <p class="count-down-item-text js-msecs">22</p>
                    <span class="count-down-item-label">{{msecStr}}</span>
                  </div>
                </div>
              </div>
              
              <div class='add-btn'>
                <a href="{{promotionBuyUrl}}" target="_blank" class="complete" @click="whenCloseWin">
                  <span>{{buyNowStr}}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="close-it" @click="whenCloseWin"></div>
      </div>
      <div class="rec-promotion-bg">
        <div class="red-img1"></div>
        <div class="red-img2"></div>
        <div class="red-img3"></div>
        <div class="red-img4"></div>
        <div class="red-img5"></div>
        <div class="red-img6"></div>
        <div class="red-img7"></div>
      </div>

    </div>
      `,
      titleStr: apower.tr("promotion.title"),
      desStr: apower.tr("promotion.des"),
      buy1get2Str: apower.tr("promotion.buy1get2"),
      unlimitedPackStr: apower.tr("promotion.unlimitedPack"),
      offerEndStr: apower.tr("promotion.offerEnd"),
      hourStr: apower.tr("promotion.hour"),
      minStr: apower.tr("promotion.min"),
      secStr: apower.tr("promotion.sec"),
      msecStr: apower.tr("promotion.msec"),
      buyNowStr: apower.tr("promotion.buyNow"),
      promotionBuyUrl: window["promotionBuyUrl"]
        ? window["promotionBuyUrl"]
        : "/",
    });
    $.registerOnce(".count-down-box", function () {
      var $daysEl = this.el.find(".js-days");
      var $hrsEl = this.el.find(".js-hrs");
      var $minsEl = this.el.find(".js-mins");
      var $secsEl = this.el.find(".js-secs");
      var $msecsEl = this.el.find(".js-msecs");

      function setTime() {
        var time = 3 * 24 * 3600000 - (Date.now() % (3 * 24 * 3600000));
        var days = parseInt(time / (24 * 3600000));
        var hrs = parseInt((time % (24 * 3600000)) / 3600000);
        var mins = parseInt(((time % (24 * 3600000)) % 3600000) / 60000);
        var secs = parseInt(
          (((time % (24 * 3600000)) % 3600000) % 60000) / 1000
        );
        var msecs = parseInt(time % 1000);
        if (msecs < 100) {
          msecs = "000".substring(0, 3 - (msecs + "").length) + msecs;
        }

        // $daysEl.text(days)
        $hrsEl.text(hrs);
        $minsEl.text(mins);
        $secsEl.text(secs);
        $msecsEl.text(msecs);
      }

      setTime();
      setInterval(setTime, 53);
    });

    if (window["promotionOn"]) {
      // 需要在php中开启这个变量
      // if(1){
      let win = $.newComponent("rec-promotion");
      win.show();
    }
  },
});

          })
        